import { Tab, TabList } from "@fluentui/react-components";
import { PreferenceSection } from "../../../utils/enums";

interface PreferencesSidebarProps {
  selectedSection: string;
  setSelectedSection: (section: PreferenceSection) => void;
  menuItems: ReadonlyArray<{
    readonly id: PreferenceSection;
    readonly label: string;
  }>;
};

const PreferencesSidebarMenu = ({ 
  selectedSection, 
  setSelectedSection,
  menuItems
}: PreferencesSidebarProps) => {

  const containerStyle = {
    width: "256px",
    height: "100%"
  };

  const tabListStyle = {
    display: 'flex',
    flexDirection: 'column' as const,
  };

  const tabStyle = {
    justifyContent: 'flex-start',
    padding: '8px 16px',
    textAlign: 'left' as const,
    ':hover': {
      backgroundColor: '#f5f5f5'
    },
  };

  return (
    <div style={containerStyle}>
      <TabList 
        vertical 
        style={tabListStyle}
        selectedValue={selectedSection}
        onTabSelect={(_, data) => setSelectedSection(data.value as PreferenceSection)}
      >
        {menuItems.map((item) => (
          <Tab 
            key={item.id} 
            value={item.id}
            style={tabStyle}
          >
            {item.label}
          </Tab>
        ))}
      </TabList>
    </div>
  );
};

export default PreferencesSidebarMenu;